import React from "react";
import "./CTA.css";

const CTA = () => {
  return (
    <section id="cta" className="cta">
      <div className="container">
        <div className="cta-content">
          <h2>Ready to Never Forget Again?</h2>
          <p>
            🇮🇳 Start Your Free trial Today, For Few Days No need to Pay any
            Amount. We as MERABUDDY Team Insist You to Send this Your Near &
            Dear for Maximum Utilisation. Thank You So much for Your Time &
            Support in this Socio Economic Project 🙏, Team MERABUDDY
          </p>

          <div className="cta-form">
            <div className="form-group">
              <input
                type="email"
                placeholder="Enter your email address"
                className="email-input"
              />
              <button className="btn btn-primary">Start Organizing</button>
            </div>
            <p className="form-note">
              No credit card required. Start your free trial today.
            </p>
          </div>

          <div className="trust-indicators">
            <div className="trust-item">
              <span>⏰</span>
              <p>Never Miss Again</p>
            </div>
            <div className="trust-item">
              <span>⚡</span>
              <p>Instant Setup</p>
            </div>
            <div className="trust-item">
              <span>💯</span>
              <p>Free Trial</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
